/**
 * @packageDocumentation
 * @module f1/fn
 */

import { t_arr, t_key, t_rec } from '../types';
import is_array from '../is/is_array';
import is_record from '../is/is_record';

export interface Mimic {
  /**
   * Create a new object based on the adt provided
   *
   * @public
   * @function f1.mimic
   * @param u an adt or value to mimic
   * @example
   *
   * ```ts
   * f1.mimic({ a: 1}) => {}
   * f1.mimic([ 'a' ]) => []
   * f1.mimic('abcde') => 'abcde'
   * ```
   */
  <V>(u: t_arr<V> | t_rec<t_key, V> | V): t_arr<V> | t_rec<t_key, V> | V;
}

/**
 * @see Mimic
 */
function mimic<V>(u: t_rec<t_key, V>): t_rec<t_key, V>;
function mimic<V>(u: t_arr<V>): t_arr<V>;
function mimic<V>(u: V): V;
function mimic<V>(u: t_arr<V> | t_rec<t_key, V> | V): t_arr<V> | t_rec<t_key, V> | V {
  return is_array(u) ? [] : is_record(u) ? {} : u;
}

export default mimic;
